import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
//import "firebase/messaging";

import store from "./../store";

const firebaseConfig = {
  apiKey: "AIzaSyBB5UraNUZhBFTitcg6uvQNx0xYzoKKrEk",
  authDomain: "violent-noises.firebaseapp.com",
  databaseURL: "https://violent-noises.firebaseio.com",
  projectId: "violent-noises",
  storageBucket: "violent-noises.appspot.com",
  messagingSenderId: "975796831265",
  appId: "1:975796831265:web:4f7760985a79d7f3d34f60"
};

firebase.initializeApp(firebaseConfig);

//firebase.auth().languageCode = 'pt-br';
// To apply the default browser preference instead of explicitly setting it.
firebase.auth().useDeviceLanguage();

/*
const messaging = firebase.messaging();

messaging.usePublicVapidKey("BKA76K3T8-wPkOKdrlOQHlS4yjnrB1WfOHsPMSuHCDSF1tOXcdl0RdvFZp5NZMDnAdOn0hIfuLEYKPwkCW6BUGM");
*/

firebase.auth().onIdTokenChanged(user => {
  if (user) {
    user
      .getIdToken()
      .then(idtoken => {
        console.log("Atualizando Token");
        store.commit("setIdToken", idtoken);
        store.commit("setIdTokenExp", new Date(Date.now() + 40 * 60000));
      })
      .finally(() => {});
  } else {
    store.commit("setIdToken", "");
    store.commit("setIdTokenExp", new Date(Date.now()));
  }
});

firebase.auth().onAuthStateChanged(function(user) {
  if (user) {
    store.commit("setUserId", user.uid);
    store.commit("setDisplayName", user.displayName);
    store.commit("setEmail", user.email);
    store.commit("setPhoneNumber", user.phoneNumber);
    store.commit("setPhotoURL", user.photoURL);

    user.getIdTokenResult().then(idtokenresult => {
      let customClaims = {};

      const propnames = Object.keys(idtokenresult.claims);

      for (let i = 0; i < idtokenresult.claims.length; i++) {
        customClaims[propnames[i]] = idtokenresult.claims[i];
      }

      store.commit("setClaims", customClaims);
    });

  } else {
    // User is signed out.
    // ...
    store.commit("setUserId", "");
    store.commit("setDisplayName", "");
    store.commit("setEmail", "");
    store.commit("setPhoneNumber", "");
    store.commit("setPhotoURL", "");
    store.commit("setClaims", {});
  }
});

export default firebase;
